export interface FetchFMFByIDResponse {
    status: boolean;
    FMF: FMFByID;
}

export interface FMFByID {
    id: number;
    institutionId: number;
    status: string;
    clientFullname: string;
    creationDate: Date | null; 
    patientFullname: string;
    patientIdNumber: string;
    patientGender: string;
    patientBirthdate: string;
    patientAddress: string;
    patientHealthPlan: string;
    patientPhoneNumber: string;
    patientEmail: string;
    patientIdCard: string;
    chestPerimeter: number;
    correctionPressure: number;
    PCPosition: string;
    model: string;
    mammaryDevelopment: string;
    size: number;
    observations: string | null;
}
